import _ from 'lodash';

export const debounceLarge = _.debounce((func) => {
  func();
}, 1000);

export const debounceSmall = _.debounce((func) => {
  func();
}, 100);
